import React from "react";
import StampCard from "./StampCard";

export default function StampGrid({ items, flippedSet, onToggle, rotations }) {
  return (
    <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
      {items.map((item, i) => (
        <StampCard
          key={item.id}
          item={item}
          index={i}
          flipped={flippedSet.has(item.id)}
          onToggle={onToggle}
          rotateDeg={rotations.get(item.id) ?? 0}
        />
      ))}
    </div>
  );
}

